export default __webpack_public_path__ + "static/media/ic_baseline-call.7b7dda1e.svg";